// filter options which can be used with text search
const userFilters = ["username", "firstname", "lastname", "company"];

export default userFilters;
export const NOT_DATA_FOUND = "No Data Found";
export const RANKED_COMPANIES_BY_LOGIN_COUNT = "rankedCompaniesByLoginCount";
export const RANKED_DEPARTMENTS_BY_LOGIN_COUNT = "rankedDepartmentsByLoginCount";

// manageCompliance data Filter key
export const configKeys = ["emailId", "config"];
export const userKeys = ["firstname", "lastname", "company"];

// date range constant
export const YEAR_LIMIT = 5;
